module.exports = __webpack_public_path__ + "themes/fq/sprite/sas-small-reduced.json";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite/sas-small-reduced.json
// module id = 101
// module chunks = d-game